import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';

const ModeSelector = ({ 
    mode, 
    handleModeChange, 
    cropPosition, 
    handleCropPositionChange 
}) => {

    // クロップ位置と表示名をマッピング
    const cropPositions = [
        { value: "top-left", label: "左上" },
        { value: "top-center", label: "中央上" },
        { value: "top-right", label: "右上" },
        { value: "center", label: "中央" },
        { value: "bottom-right", label: "右下" },
        { value: "bottom-left", label: "左下" }
    ];

    return (
        <Box sx={{ textAlign: 'center', mb: 3 }}>
            {/* ✅ リサイズモード選択 */}
            <ToggleButtonGroup
                value={mode}
                exclusive
                onChange={(e, newMode) => handleModeChange(newMode)}
                aria-label="resize mode"
            >
                <ToggleButton 
                    value="aspect" 
                    aria-label="aspect"
                    color="primary"
                    sx={{ px: 4 }}
                >
                    比率を維持
                </ToggleButton>

                <ToggleButton 
                    value="crop" 
                    aria-label="crop"
                    color="primary"
                    sx={{ px: 4 }}
                >
                    クロップ
                </ToggleButton>
            </ToggleButtonGroup>

            {/* ✅ クロップモードの場合、起点選択を表示 */}
            {mode === 'crop' && (
                <Box sx={{ mt: 2 }}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>起点選択</Typography>
                    <ToggleButtonGroup
                        value={cropPosition}
                        exclusive
                        onChange={(e, newPosition) => handleCropPositionChange(newPosition)}
                        aria-label="crop position"
                    >
                        {cropPositions.map((pos) => (
                            <ToggleButton 
                                key={pos.value} 
                                value={pos.value} 
                                color="primary"
                            >
                                {pos.label}
                            </ToggleButton>
                        ))}
                    </ToggleButtonGroup>
                </Box>
            )}
        </Box>
    );
};

export default ModeSelector;
